// store/modules/toasts.js

const state = () => ({
    toasts: [],
});

const mutations = {
    addToast(state, toast) {
        state.toasts = [...state.toasts, toast];
    },
};

const actions = {
    addToast({ commit }, toast) {
        commit("addToast", toast);
    },
};

const getters = {
    toasts(state) {
        return state.toasts;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
